
import React from 'react';

interface SeedPhraseDisplayProps {
  seedPhrase: string[];
}

const SeedPhraseDisplay = ({ seedPhrase }: SeedPhraseDisplayProps) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 p-6 bg-gray-900 rounded-lg border-2 border-gray-600">
      {seedPhrase.map((word: string, index: number) => (
        <div key={index} className="bg-gray-800 px-4 py-3 rounded-lg text-center border border-gray-600 hover:border-sports-green transition-colors">
          <span className="text-xs text-gray-400 block">{index + 1}</span>
          <span className="font-mono text-white font-semibold">{word}</span>
        </div>
      ))}
    </div>
  );
};

export default SeedPhraseDisplay;
